import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {getLayout} from './utils'
import type {MeasurementsMap, RowsAndColumnsMap} from './types'
import {createCalculateAPI} from './calculateAPI'
import {createMeasurementsMapAPI} from './measurementsMapAPIs'

interface Maps {
    measurementsMap: MeasurementsMap
    rowsAndColumnsMap: RowsAndColumnsMap
}

export const createCalculateMeasurementsAPI = ({pointers, extensionAPI}: CreateExtArgs) => {
    const populateMeasurementsMap = (compRef: CompRef, maps: Maps): void => {
        const layoutData = getLayout(extensionAPI, compRef)
        const calculate = createCalculateAPI()
        const {measurementsMap, rowsAndColumnsMap} = maps
        const measurementsMapAPI = createMeasurementsMapAPI(measurementsMap, rowsAndColumnsMap)

        const calculateParams = {calculate, measurementsMapAPI, pointers, extensionAPI, compRef, layoutData}

        calculate.width(calculateParams)
        calculate.columns(calculateParams)
        calculate.height(calculateParams)
        calculate.rows(calculateParams)
        calculate.x(calculateParams)
        calculate.y(calculateParams)

        pointers.structure.getChildren(compRef).forEach(childPointer => {
            populateMeasurementsMap(childPointer as CompRef, maps)
        })
    }

    return (compRef: CompRef): MeasurementsMap => {
        const measurementsMap = {}
        const rowsAndColumnsMap = {}
        populateMeasurementsMap(compRef, {measurementsMap, rowsAndColumnsMap})
        return measurementsMap
    }
}
